import PrivacyReminderComponent from 'mk2/components/PrivacyReminder';
import { privacyLeafletAcceptTrigger } from 'mk2/containers/PrivacyReminder/PrivacyReminder.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getRequestPrivacyLeaflet } from 'mk2/reducers';
import * as React from 'react';
import { connect } from 'react-redux';

interface OwnProps {
    currentUrl: string;
    fluxibleCompatibility: boolean;
}

interface StateProps {
    privacyLeaflet: boolean;
}

interface DispatchProps {
    onPrivacyLeafletAccept();
}

type Props = OwnProps & StateProps & DispatchProps;

class PrivacyReminder extends React.Component<Props> {
    public render() {
        return (
            <PrivacyReminderComponent
                fluxibleCompatibility={this.props.fluxibleCompatibility}
                currentUrl={this.props.currentUrl}
                showPrivacyReminder={!this.props.privacyLeaflet}
                onPrivacyLeafletAccept={this.props.onPrivacyLeafletAccept}
            />
        );
    }
}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    return {
        privacyLeaflet: getRequestPrivacyLeaflet(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onPrivacyLeafletAccept: privacyLeafletAcceptTrigger,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyReminder);
